import { render, staticRenderFns } from "./editItemDetail.vue?vue&type=template&id=4a77ee9a&"
import script from "./editItemDetail.vue?vue&type=script&lang=ts&"
export * from "./editItemDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editItemDetail.vue"
export default component.exports